// This file generates state for OAuth flows, which is a unique string used to maintain state between the request and callback.
// It combines a timestamp and a random string to ensure uniqueness and prevent CSRF attacks.
export function generateState(): string {
  const timestamp = Date.now().toString();
  const randomString = Math.random().toString(36).substring(2);
  return timestamp + randomString;
}
